// @flow

import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  PortalNavbar,
  inactivityTimer,
  environment,
  ContactCard,
  OauthTokenValidator
} from "buba-components";
import contactPerson from "buba-components/src/data/contactPerson";
import { isLoggedIn as isLoggedInSelector } from "../../store/user/selectors";
import { clearUserData as clearUserDataAction } from "../../store/user/actions";
import Routes from "./routes";

import paths from "../../data/paths";
import { links } from "../../data/navLinks";

import "./App.scss";

type AppProps = {
  isLoggedIn: boolean,
  history: {
    push: (path: string) => void,
    location: { pathname: string }
  }
};

class App extends React.Component<AppProps> {
  componentDidMount() {
    this.setLogoutTimer();
  }

  setLogoutTimer = () => {
    const { history } = this.props;

    const timeout = parseInt(
      environment.getEnvironmentVariable(environment.INACTIVITY_TIMEOUT),
      10
    );
    const unset = inactivityTimer.setInactivityTimer(timeout, document);

    document.addEventListener(inactivityTimer.INACTIVITY_TIMER_HIT_EVENT_TYPE, () => {
      unset();
      history.push(paths.logout);
    });
  };

  render() {
    const { isLoggedIn } = this.props;

    return (
      <>
        <OauthTokenValidator logOutAction={clearUserDataAction} />
        <PortalNavbar
          links={links}
          logoLink={isLoggedIn ? paths.bankInquiriesListNew : paths.login}
          isLoggedIn={isLoggedIn}
          logOutLink={paths.logout}
        />
        <ContactCard {...contactPerson} />
        <Routes />
      </>
    );
  }
}

export default withRouter(
  connect(state => ({
    isLoggedIn: isLoggedInSelector(state)
  }))(App)
);
